<template>
    <div>
        <b-button variant="link" @click.prevent="abrirChat()"><small>Ver mensagem</small></b-button>


    </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import ReactFrame from "../ReactFrame.vue";
import windowChat from "../../sistema/Window.vue";
export default {
    components: {ReactFrame, windowChat},
    props: {
        item: Object
    },
    data() {
        return {
            window_visible: false,
        };
    },
    methods: {
        ...mapActions("notification", ["markAsRead"]),
        ...mapMutations('chat', ['setClient', 'setVisible', 'setIsActive']),
        abrirChat() {
            this.setClient(this.item.data.message.client_id);
            this.setVisible(true);
            this.setIsActive(true);
            this.read();
        },
        read() {
            this.markAsRead(this.item);
            this.$emit("hideDropdown");
        },

    }
}
</script>
